import {
  Box,
  Button,
  Flex,
  HStack,
  TableContainer,
  useDisclosure,
  Text,
  Table,
  Th,
  Tbody,
  Tr,
  Td,
  VStack,
  Avatar,
  Spinner,
  Thead,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Header from '../../../components/header/Header';
import SearchBar from '../../../components/searchbar/SearchBar';
import moment from 'moment';
import { mutateFunction, useMutation } from '../../../libs/apis';
import { CustomToast } from '../../../components/toast/CustomToast';
import { useData } from '../../../data';
import IsDesktop from '../../../utils/IsDesktop';
import ViewUserDetails from './ViewUserDetails';
import UserCountSection from './UsersCountSection';
import { BsDownload } from 'react-icons/bs';
import exportToCSV from '../../../utils/ExportToCSV';
import BrandButton from '../../../components/brandButton/BrandButton';
import { useSelector } from 'react-redux';
import PermissionBlinder from '../../../components/PermissionBlinder';

const DeletedUsers = () => {
  const { data, isLoading, refetch } = useData('admins/get-deletion-request');
  const [displayedListStatus, setDisplayedListStatus] = useState('all');
  const [displayedList, setDisplayedList] = useState([]);
  const { isOpen, onToggle: onToggleUserDetails } = useDisclosure();
  const [selecteduser, setSelectedUser] = useState();
  const { mutate } = useMutation(mutateFunction);
  const { addToast } = CustomToast();
  const isDesktop = IsDesktop();
  const permissions = useSelector(
    (state) => state?.user?.userInfo?.permissions,
  );

  const changeUserView = (advertStatus) => {
    setDisplayedListStatus(advertStatus);
  };
  const viewUser = (user) => {
    setSelectedUser(user);
    onToggleUserDetails();
  };

  const downloadCSV = () => {
    const __data = displayedList.map((item) => {
      return [
        `${item.firstName} ${item.lastName}`,
        item.email,
        item.firstName === item.initiator ? 'Self' : item.initiator,
        moment(item.createdAt).format('DD/MM/YYYY [at] HH:mm'),
        item.confirmedAt
          ? moment(item.confirmedAt).format('DD/MM/YYYY [at] HH:mm')
          : '',
      ];
    });

    __data.unshift([
      'Profile',
      'Email',
      'Initiated By',
      'Initiated At',
      'Confirmed At',
    ]);

    exportToCSV(__data, 'seedafounder_deleted_users.csv');
  };

  const sortList = (advertActiveStatus) => {
    if (advertActiveStatus === 'all') {
      return data?.data?.users;
    }
    return data?.data?.users?.filter(
      (user) => advertActiveStatus === moment(user?.confirmedAt).isValid(),
    );
  };
  useEffect(() => {
    if (data?.data) {
      setDisplayedList(sortList(displayedListStatus));
    }
  }, [data, displayedListStatus]);

  if(permissions && !permissions?.can_manage_deleted_users){
    return <PermissionBlinder />
  }
  return (
    <>
      <Box>
        <Header title="Deleted Users" />
        {isOpen && (
          <ViewUserDetails user={selecteduser} onToggle={onToggleUserDetails} />
        )}
        {!isOpen && (
          <>
            <Flex w="100%">
              <Box mt="20px" w="100%">
                <HStack
                  w="80%"
                  justifyContent="space-between"
                  className="items-start flex-wrap gap-2"
                >
                  <UserCountSection
                    totalUsers={data?.data?.totalUsers}
                    totalDeleted={data?.data?.totalDeleted}
                    totalRequested={data?.data?.totalRequested}
                  />
                  <BrandButton
                    text="Download CSV"
                    minW="140px"
                    onClick={downloadCSV}
                  />
                </HStack>
                <Flex w="100%" justify="space-between" alignItems="center">
                  <SearchBar
                    searchType="deleted-user"
                    searchRoute="admins/search-deletion-request"
                    onSelectOption={(advert) => {
                      viewUser(advert);
                    }}
                  />
                  <Flex alignItems="flex-start" pr={2} h="29px" w="67">
                    <Button
                      bg={
                        displayedListStatus === 'all'
                          ? 'brand.primary'
                          : '#FFFFFF'
                      }
                      color={
                        displayedListStatus === 'all'
                          ? '#FFFFFF'
                          : 'brand.primary'
                      }
                      _hover={{ bg: '#134A70', color: '#FFFFFF' }}
                      borderRadius="5px 0px 0px 5px"
                      boxShadow="base"
                      onClick={() => changeUserView('all')}
                    >
                      All
                    </Button>
                    <Button
                      bg={
                        displayedListStatus === true
                          ? 'brand.primary'
                          : '#FFFFFF'
                      }
                      color={
                        displayedListStatus === true
                          ? '#FFFFFF'
                          : 'brand.primary'
                      }
                      _hover={{ bg: '#134A70', color: '#FFFFFF' }}
                      boxShadow="base"
                      borderRadius="0px"
                      onClick={() => changeUserView(true)}
                    >
                      Deleted
                    </Button>
                    <Button
                      bg={
                        displayedListStatus === false
                          ? 'brand.primary'
                          : '#FFFFFF'
                      }
                      color={
                        displayedListStatus === false
                          ? '#FFFFFF'
                          : 'brand.primary'
                      }
                      _hover={{ bg: '#134A70', color: '#FFFFFF' }}
                      boxShadow="base"
                      borderRadius="0px 5px 5px 0px"
                      onClick={() => changeUserView(false)}
                    >
                      Requested
                    </Button>
                  </Flex>
                </Flex>
              </Box>
            </Flex>
            <Box
              className={`flex-col w-full overflow-x-auto ${
                isDesktop
                  ? 'max-h-[75vh] fixed mt-5 px-2 pb-32 overflow-y-scroll'
                  : ''
              }`}
            >
              <TableContainer
                mt="50px"
                borderRadius="10px"
                overflowX="auto"
                w="100%"
              >
                <Table
                  variant="simple"
                  size="sm"
                  fontSize="12px"
                  w={['100%', '100%', '95%', '90%']}
                  minWidth="900px"
                >
                  <Thead>
                    <Tr>
                      <Th minW="60px">S/N</Th>
                      <Th minW="180px">Profile</Th>
                      <Th minW="220px">Email</Th>
                      <Th minW="140px">Initiated By</Th>
                      <Th minW="180px">Initiated At</Th>
                      <Th minW="180px">Confirmed At</Th>
                    </Tr>
                  </Thead>
                  {!isLoading ? (
                    <Tbody>
                      {displayedList?.map((item, index) => {
                        return (
                          <Tr
                            key={item.id}
                            style={{ padding: '2rem 2rem', height: '80px' }}
                            boxShadow="md"
                            borderRadius="10px"
                            _hover={{
                              borderWidth: '2px',
                              borderColor: 'brand.primary',
                              borderRadius: '10px',
                            }}
                          >
                            <Td minW="60px">{index + 1}</Td>
                            <Td minW="180px">
                              <Flex alignItems="center">
                                <Text className="capitalize">
                                  {`${item.firstName} ${item.lastName}`}
                                </Text>
                              </Flex>
                            </Td>
                            <Td minW="220px">
                              <Text>{item.email}</Text>
                            </Td>
                            <Td minW="140px">
                              <Text>
                                {item.firstName === item.initiator
                                  ? 'Self'
                                  : item.initiator}
                              </Text>
                            </Td>
                            <Td minW="180px">
                              <VStack
                                justifyContent="center"
                                alignItems="flex-start"
                              >
                                <Text fontSize="12px" color="gray">
                                  {moment(item.createdAt).format(
                                    'DD/MM/YYYY [at] HH:mm',
                                  )}
                                </Text>
                              </VStack>
                            </Td>
                            <Td minW="180px">
                              <VStack
                                justifyContent="center"
                                alignItems="flex-start"
                              >
                                <Text fontSize="12px" color="gray">
                                  {item.confirmedAt
                                    ? moment(item.confirmedAt).format(
                                        'DD/MM/YYYY [at] HH:mm',
                                      )
                                    : '-'}
                                </Text>
                              </VStack>
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  ) : (
                    <Spinner m={5} />
                  )}
                </Table>
              </TableContainer>
            </Box>
          </>
        )}
      </Box>
    </>
  );
};
export default DeletedUsers;
